var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import Menu from "src/decidim/menu";
import { screens } from "tailwindcss/defaultTheme";
export default class MobileMenu extends Menu {
  constructor(opts = {}) {
    super(opts);
    __publicField(this, "navItemBackBtnSelector", ".main-nav__item-parent-back-btn");
    __publicField(this, "menuDropdownTrigger", document.getElementById("main-dropdown-summary-mobile"));
    __publicField(this, "menuDropdown", document.getElementById("dropdown-menu-main-mobile"));
    __publicField(this, "skipElementSelectors", ["#trigger-dropdown-mobile-language-selector-dropdown"]);
    __publicField(this, "omniPresentBanner", document.querySelector(".omnipresent-banner"));
    __publicField(this, "stickyHeader", document.getElementById("sticky-header-container"));
  }
  bindEvents() {
    super.bindEvents();
    this._handleCloseDropdown = this._handleCloseDropdown.bind(this);
    this._handleOpenDropdown = this._handleOpenDropdown.bind(this);
    this._handleScreenChangeEvent = this._handleScreenChangeEvent.bind(this);
  }
  initListeners() {
    super.initListeners();
    console.log("initListeners");
    window.addEventListener("pageshow", () => this._closeDropdown());
    this.menuDropdown.addEventListener("open.a11y.dropdown", this._handleOpenDropdown);
    this.menuDropdown.addEventListener("close.a11y.dropdown", this._handleCloseDropdown);
    window.matchMedia(`(min-width: ${screens.lg})`).addEventListener("change", this._handleScreenChangeEvent);
    if (this.omniPresentBanner) {
      const omniPresentBannerResizeObserver = new ResizeObserver(this._handleResizeOmniPresentBanner.bind(this));
      omniPresentBannerResizeObserver.observe(this.omniPresentBanner);
    }
  }
  _closeDropdown() {
    this.menuDropdown.setAttribute("aria-hidden", "true");
    this.menuDropdownTrigger.setAttribute("aria-expanded", "false");
  }
  _handleBackToParentItem(event) {
    if (event.target.closest(this.navItemBackBtnSelector)) {
      this.focusGuard.disable();
      this.triggerElement.focus();
      this.focusGuard.trap(this.menuDropdown, this.triggerElement);
      this.close();
    }
  }
  _handleResizeOmniPresentBanner(entries) {
    console.log("omniPresentBanner");
    this.stickyHeader.style.setProperty("--omnipresent-banner-height", entries[0].target.clientHeight + "px");
  }
  _handleCloseDropdown(event) {
    const shouldSkip = this.skipElementSelectors.some((selector) => event.target.closest(selector));
    if (shouldSkip) {
      return;
    }
    this.close();
    this.focusGuard.disable();
    document.body.classList.remove("overflow-hidden");
  }
  _handleOpenDropdown() {
    document.body.classList.add("overflow-hidden");
    this.focusGuard.trap(this.menuDropdown, this.menuDropdownTrigger);
  }
  _handleScreenChangeEvent() {
    if (this.menuDropdown.ariaHidden === "false") {
      this.menuDropdownTrigger.click();
    }
  }
  _handleNavItemClick(event) {
    super._toggleItem(event);
    this._handleBackToParentItem(event);
  }
  _handleNavItemFocusIn() {
    return false;
  }
}
